function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["text", "element", "type", "variant", "skin", "size", "shape", "fluid", "isFluid", "disabled", "iconLeft", "iconRight", "customIconLeft", "customIconRight", "hideText", "isLoading", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { string, oneOf, oneOfType, func, bool, element, object } from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import './Button.scss';
import ProgressRadial from '../ProgressRadial';
var propTypes = {
  /** Button text */
  text: string.isRequired,

  /** The type of element you need. `button`, `a` or `Link` (from react router) are recommended.
   * Example usage with React Router: `<Button element={Link} to="/somepage" text="My Text"/>` */
  element: oneOfType([string, func, object]),

  /**
   * `submit`: The button submits the form data to the server. This is the default if the attribute is not specified, or if the attribute is dynamically changed to an empty or invalid value.<br>
   * `reset`: The button resets all the controls to their initial values.<br>
   * `button`: The button has no default behavior. It can have client-side scripts associated with the element's events, which are triggered when the events occur.
   * */
  type: oneOf(['button', 'submit', 'reset']),

  /** Choose between these variants: */
  variant: oneOf(['filled', 'outline', 'flat']),

  /** Choose between these skins: */
  skin: oneOf(['dark', 'light', 'success', 'danger', 'info']),

  /** Choose between these sizes: */
  size: oneOf(['small', 'medium', 'large']),

  /** Choose between these shapes: */
  shape: oneOf(['rounded', 'pill']),

  /** @deprecated Use `isFluid` instead */
  fluid: bool,

  /** Makes the button fill the parents available space */
  isFluid: bool,

  /** Make the button disabled */
  disabled: bool,

  /** Place icon before text.*/
  iconLeft: element,

  /** Place icon after text. */
  iconRight: element,

  /** Place custom icon before text. */
  customIconLeft: string,

  /** Place custom icon after text. */
  customIconRight: string,

  /** Hides the text visually. Still available for screen readers */
  hideText: bool,

  /** Visually hides the content of the button and displays a loading spinner */
  isLoading: bool,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  element: 'button',
  type: 'button'
};
/** A Button is a clickable element used to initialize an action. */

var Button = /*#__PURE__*/function (_Component) {
  _inherits(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    _classCallCheck(this, Button);

    return _super.apply(this, arguments);
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          Element = _this$props.element,
          type = _this$props.type,
          variant = _this$props.variant,
          skin = _this$props.skin,
          size = _this$props.size,
          shape = _this$props.shape,
          fluid = _this$props.fluid,
          isFluid = _this$props.isFluid,
          disabled = _this$props.disabled,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          customIconLeft = _this$props.customIconLeft,
          customIconRight = _this$props.customIconRight,
          hideText = _this$props.hideText,
          isLoading = _this$props.isLoading,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var iconSize = size;
      var componentClassNames = classNames('rds-btn', {
        'rds-btn--filled': variant === 'filled',
        'rds-btn--outline': variant === 'outline',
        'rds-btn--flat': variant === 'flat',
        'rds-btn--dark': skin === 'dark' || skin === '' || !skin || skin === 'default',
        'rds-btn--light': skin === 'light' || skin === 'inverted',
        'rds-btn--success': skin === 'success',
        'rds-btn--danger': skin === 'danger',
        'rds-btn--info': skin === 'info',
        'rds-btn--small': size === 'small',
        'rds-btn--medium': size === 'medium',
        'rds-btn--large': size === 'large',
        'rds-btn--rounded': shape === 'rounded',
        'rds-btn--pill': shape === 'pill',
        'rds-is-fluid': fluid || isFluid,
        'rds-btn--disabled': disabled,
        'rds-btn--icon-only': !text || text === '' || hideText,
        'rds-btn--has-icon-left': iconLeft || customIconLeft,
        'rds-btn--has-icon-right': iconRight || customIconRight,
        'rds-btn--is-loading': isLoading
      }, className);
      var textClassNames = classNames('rds-btn__text', {
        'rds-is-vishidden': hideText
      });
      var buttonContent = /*#__PURE__*/React.createElement("span", {
        className: 'rds-btn__content'
      }, isLoading && /*#__PURE__*/React.createElement(ProgressRadial, {
        isIndeterminate: true,
        size: size === 'large' ? 'medium' : 'small',
        skin: 'inherit',
        className: 'rds-btn__progress'
      }), iconLeft && !customIconLeft && /*#__PURE__*/React.createElement(Icon, {
        component: iconLeft,
        size: iconSize,
        className: "rds-btn__icn"
      }), customIconLeft && /*#__PURE__*/React.createElement(Icon, {
        customIconPath: customIconLeft,
        size: iconSize,
        className: "rds-btn__icn"
      }), /*#__PURE__*/React.createElement("span", {
        className: textClassNames
      }, text), iconRight && !customIconRight && /*#__PURE__*/React.createElement(Icon, {
        component: iconRight,
        size: iconSize,
        className: "rds-btn__icn"
      }), customIconRight && /*#__PURE__*/React.createElement(Icon, {
        customIconPath: customIconRight,
        size: iconSize,
        className: "rds-btn__icn"
      }));

      if (skin === 'default' || skin === 'inverted') {
        console.error("Skin ".concat(skin, " is deprecated. Please use ").concat(skin === 'default' ? 'dark' : 'light', " instead."));
      }

      return Element !== 'a' ? /*#__PURE__*/React.createElement(Element, _extends({
        className: componentClassNames,
        type: Element === 'button' ? type : null,
        disabled: disabled
      }, rest), buttonContent) : disabled ? /*#__PURE__*/React.createElement("span", {
        className: componentClassNames
      }, buttonContent) : /*#__PURE__*/React.createElement("a", _extends({
        className: componentClassNames
      }, rest), buttonContent);
    }
  }]);

  return Button;
}(Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
export default Button;